// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* line 2, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */
.cam-add-listener > button {
  position: relative;
  margin-left: 10px;
}
/* line 8, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */
[data-list-entry-container] > .bpp-listener-area {
  border: 1px solid #ccc;
  margin: 10px 1px;
  padding: 10px;
}
/* line 14, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */
.bpp-listener-area {
  position: relative;
}
/* line 16, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */
.bpp-listener-area > button {
  position: absolute;
  right: 0;
  top: 0;
  border: none;
  background: none;
}
/* line 25, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */
.bpp-listener-area + .bpp-listener-area {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./ModuleViews/Administration/BusinessProcesses/css/listeners.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;AACA,yEAAyE;AACzE;EACE,kBAAkB;AACpB;AACA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;AACA,yEAAyE;AACzE;EACE,gBAAgB;AAClB","sourcesContent":["/* line 2, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */\n.cam-add-listener > button {\n  position: relative;\n  margin-left: 10px;\n}\n/* line 8, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */\n[data-list-entry-container] > .bpp-listener-area {\n  border: 1px solid #ccc;\n  margin: 10px 1px;\n  padding: 10px;\n}\n/* line 14, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */\n.bpp-listener-area {\n  position: relative;\n}\n/* line 16, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */\n.bpp-listener-area > button {\n  position: absolute;\n  right: 0;\n  top: 0;\n  border: none;\n  background: none;\n}\n/* line 25, node_modules\\bpmn-js-properties-panel\\styles\\listeners.less */\n.bpp-listener-area + .bpp-listener-area {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
